import { Viewer, Worker } from "@react-pdf-viewer/core";
import React from "react";
import "./CustomPDFViewerStyles.css";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useSearchParams } from "react-router-dom";
function CustomPDFViewer() {
  //extract ur from react router params
  const [searchParams] = useSearchParams();
  const uri = searchParams.get("source_uri");
  if (!uri) {
    return null;
  }
  return (
    <div className="print-container no-right-click disable-select">
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}
      >
        <Viewer fileUrl={uri} />
      </Worker>
    </div>
  );
}

export default CustomPDFViewer;
